import { useActiveCircle } from '@rhg/hooks/use-active-circle';
import { useCircle } from '@rhg/hooks/use-circle';
import createMediaApi from '@rhg/libs/api/create-media-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { invalidateQueryKey, queryKeys, useQuery } from '@rhg/libs/react-query';
import { getRhgAppHeader } from '@rhg/utils/browser';

export function guideQueryKey({
    programId,
    packClass,
    guideId,
}: {
    programId?: string;
    packClass?: string;
    guideId?: string;
}) {
    return [queryKeys.guide, programId, packClass, guideId];
}

export default function useRecipientGuide({
    programId,
    packClass,
    guideId,
}: {
    programId?: string;
    packClass?: string;
    guideId?: string;
}) {
    const { isAuthenticated, getAccessTokenSilently } = useAuth();
    const { activeCircleId: circleId, isFetched: isActiveCircleFetched } =
        useActiveCircle();
    const { circle, isFetched: isCircleFetched } = useCircle(circleId);
    const circleAuthorizationToken = circle?.authorizationJWT ?? '';
    const enabled = !!(
        isCircleFetched &&
        isActiveCircleFetched &&
        isAuthenticated &&
        programId &&
        packClass &&
        guideId &&
        circleId > 0 &&
        circleAuthorizationToken
    );
    const rHGApp = getRhgAppHeader();

    const queryKey = guideQueryKey({ programId, packClass, guideId });
    const { data, ...otherProps } = useQuery({
        queryKey,
        queryFn: async () => {
            const mediaApi = createMediaApi(getAccessTokenSilently);

            const response = await mediaApi.getRecipientGuide({
                rHGApp,
                _class: packClass || '',
                recipientId: circleId,
                programId: programId || '',
                guideId: guideId || '',
                circleAuthorizationToken,
            });

            return response.data;
        },
        enabled,
    });

    const refresh = () => {
        invalidateQueryKey(queryKey);
    };

    return {
        refresh,
        guide: data,
        ...otherProps,
    };
}
